var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.btnFlag === "examination"
    ? _c(
        "div",
        {
          class:
            _vm.productFlag == 1 ? "platform_jump_btn" : "platform_jump_btn1"
        },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "bury",
                  rawName: "v-bury",
                  value: { start: true },
                  expression: "{ start: true }"
                }
              ],
              ref: "startSoftware",
              attrs: { type: "primary", href: _vm.startSoftwareUrl },
              on: {
                click: function($event) {
                  return _vm.goStudy()
                }
              }
            },
            [_vm._v("开始答题\n  ")]
          )
        ],
        1
      )
    : _vm.btnFlag === "previewExam"
    ? _c("div", { staticClass: "paper_preview" }, [
        _c(
          "span",
          {
            staticClass: "intoSystem",
            on: {
              click: function($event) {
                return _vm.goStudy()
              }
            }
          },
          [
            _vm._v("进入实操系统"),
            _c("img", { attrs: { src: "/static/images/study/icon/right.png" } })
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-540e1c6b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-540e1c6b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/platformBtn/examination.vue
// module id = null
// module chunks = 